// @ts-nocheck
import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import Head from 'next/head';
import Router, { useRouter } from 'next/router';
import Breadcrumbs from '@/components/breadcrumbs';
import Tabs from '@/components/tabs';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import Helper from '@/utils/helper';
import Attachments from '@/components/shared-views/attachments';
import Appointments from '@/components/shared-views/appointments';
import Communications from '@/components/shared-views/communications';
import JobDetails from '@/PageComponents/Job/job-details';
import Timers from '@/components/job/timers';
import TimerContext from '@/utils/timer-context';
import StatusChange from '@/components/job/status-change';
import * as Enums from '@/utils/enums';
import DownloadService from '@/utils/download-service';
import JobStatusService from '@/services/job/job-status-service';
import { JobCardLengths } from '@/utils/fieldLengths/fieldLengths';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import { colors } from '@/theme/';
import ManageJobCardRepeat from '@/components/modals/jobcard/manage-job-card-repeat';
import PS from '@/services/permission/permission-service';
import TimerService from '@/services/timer-service';
import JobCustomerChange from '@/components/modals/jobcard/job-customer-change';
import Time from '@/utils/time';
import DocumentService from '@/services/document/document-service';
import constants from '@/utils/constants';
import useInitialTimeout from '@/hooks/useInitialTimeout';
import JobStatusSummaryTable from "@/PageComponents/Table/Component Tables/JobStatusSummaryTable";
import ManageLinksTableV2 from "@/PageComponents/Links/ManageLinksTableV2";
import ManageLinksModal from "@/PageComponents/Links/ManageLinksModalV2";
import {  Box, Card, Flex, Text, Button } from "@mantine/core";
import {IconCheck, IconPrinter
} from "@tabler/icons-react";
import ManageJobInventoryComponent, { useJobInventoryState } from '@/PageComponents/JobInventory/ManageJobInventoryComponent';
import useRefState from '@/hooks/useRefState';
import { getSectionsFromTableData } from "@/PageComponents/SectionTable/SectionTable";
import JobInventoryInvoicedWidget from '@/PageComponents/JobInventory/JobInventoryInvoicedWidget';
import { IconArchive} from "@tabler/icons";
import {useElementSize} from "@mantine/hooks";
import SCMessageBarContext from '@/utils/contexts/sc-message-bar-context';
import ItemQuotesTable from "@/PageComponents/Table/Component Tables/ItemQuotesTable";
import JobInvoicesTable from "@/PageComponents/Table/Component Tables/ItemInvoicesTable";
import JobPurchasesTable from "@/PageComponents/Table/Component Tables/ItemPurchasesTable";
import featureService from '@/services/feature/feature-service';
import QuoteDrawer from "@/PageComponents/Quote/QuoteDrawer";
import {useQuery} from "@tanstack/react-query";
import jobService from '@/services/job/job-service';
import { showNotification } from '@mantine/notifications';
import InvoiceDrawer from "@/PageComponents/Invoice/InvoiceDrawer";
import PurchaseOrderDrawer from "@/PageComponents/Purchases/PurchaseOrderDrawer";
import ItemStockTransactionsTable from '@/PageComponents/Table/Component Tables/ItemStockTransactionsTable';
import JobStatusChange from '@/PageComponents/Job/JobStatusChange'
import JobActions from '@/PageComponents/Job/JobActions'
import PrintModal from '@/PageComponents/Job/PrintModal'
import warehouseService from '@/services/warehouse/warehouse-service';
import FormDefinitionsForItem from '@/components/modals/form-definition/form-definitions-for-item';
import DetailsPageLoader from '@/components/details-page-loader';
import JobRunningTimerButton from '@/PageComponents/Job/JobRunningTimerButton';
import { createFileRoute } from '@tanstack/react-router'

const COUNT_DEBOUNCE_TIMEOUT = 2_000;

// The tabs / buttons row lines up with the section content (see the comment on the row);
// the slack is the row padding, the tabs' own margins and the gap before the buttons
const TOOLBAR_ALIGNED_WIDTH = 1149;
const TOOLBAR_SLACK = 80;

function JobPageInner() {

  const toast = useContext(ToastContext);
  const timerContext = useContext(TimerContext);
  const messageBarContext = useContext(SCMessageBarContext);

  const initialTimeout = useInitialTimeout(1000);

  const [hasEmployee, setHasEmployee] = useState(() => !Helper.isNullOrWhitespace(Storage.getCookie(Enums.Cookie.employeeID)));

  const [archiveDisabled, setArchiveDisabled] = useState(false);
  const [addRecurringJobPermission] = useState(PS.hasPermission(Enums.PermissionName.RecurringJob));
  const [editJobPermission, setEditJobPermission] = useState(PS.hasPermission(Enums.PermissionName.EditJob));
  const [hasManageCostingPermission] = useState(PS.hasPermission(Enums.PermissionName.ManageCosting));

  const [closeDisabled, setCloseDisabled] = useState(false);
  const [attachmentRefresh, setAttachmentRefresh] = useState(false);

  const [customerPermission] = useState(PS.hasPermission(Enums.PermissionName.Customer));
  const [quotePermission] = useState(PS.hasPermission(Enums.PermissionName.Quote));
  const [queryPermission] = useState(PS.hasPermission(Enums.PermissionName.Query));
  const [appointmentPermission] = useState(PS.hasPermission(Enums.PermissionName.Appointment));
  const [invoicePermission] = useState(PS.hasPermission(Enums.PermissionName.Invoice));
  const [purchaseOrderPermission] = useState(PS.hasPermission(Enums.PermissionName.PurchaseOrder));
  const [moduleChangeCustomerPermission] = useState(PS.hasPermission(Enums.PermissionName.ModuleChangeCustomer));
  const [manageMyTimersPermission] = useState(PS.hasPermission(Enums.PermissionName.ManageMyTimers));
  // Tasks only show for users who can add task items
  const [tasksEnabled] = useState(PS.hasPermission(Enums.PermissionName.AddTaskItems));

  const [retriggerAuditLog, setRetriggerAuditLog] = useState(false);

  const [showChangeCustomer, setShowChangeCustomer] = useState(false);

  const [formDefinitions, setFormDefinitions] = useState<any[]>([]);
  const [showFormsModal, setShowFormsModal] = useState(false);

  const [showLinkQueriesModal, setShowLinkQueriesModal] = useState(false);

  const [pageTabs, setPageTabs] = useState<any[]>([]);

  const [customer, setCustomer] = useState<any>(null);
  const [contacts, setContacts] = useState<any[]>([]);
  const [contact, setContact] = useState<any>(null);
  const [locations, setLocations] = useState<any[]>([]);
  const [location, setLocation] = useState<any>(null);

  const [selectedTab, setSelectedTab] = useState<any>(null);
  const [newStatus, setNewStatus] = useState<any>(undefined);
  const [newStatusShowStopTimerOption, setNewStatusShowStopTimerOption] = useState(false);
  const [nextJobStatuses, setNextJobStatuses] = useState<any[]>([]);
  const [showProperties, setShowProperties] = useState(true);

  // TAB STATES
  const [appointments, setAppointments] = useState<any[]>([]);
  const [timers, setTimers] = useState<any[]>([]);
  const [jobProperties, setJobProperties] = useState<any[]>([]);
  const [jobInventoryRequired, setJobInventoryRequired] = useState(false);
  const [materialsRequired, setMaterialsRequired] = useState(false);
  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());
  const [hasVans, setHasVans] = useState(false);

  const [isPrinting, setIsPrinting] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);


    // const [hasStockControl, setHasStockControl] = useState(false);
    const {data: hasStockControl} = useQuery<boolean>(['feature', 'hasFeature', constants.features.STOCK_CONTROL],
        () => featureService.hasFeature(constants.features.STOCK_CONTROL)
    )

    /*Detect route changes when timer is clicked in navbar.  Navigate to timers tab*/
  const router = useRouter()
  const { id: jobId, tab } = router.query;
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  const { data: jobQueryData } = useQuery(
    ['job', jobId],
    () => Fetch.get({ url: '/Job/' + jobId }),
    { enabled: !!jobId }
  );
  const { data: statusesQueryData } = useQuery(
    ['jobStatuses', jobId],
    () => Fetch.get({ url: '/JobStatus/Next', params: { jobCardID: jobId } }),
    { enabled: !!jobId }
  );
  const { data: jobPropsQueryData } = useQuery(
    ['jobPropsData', jobId],
    () => Fetch.get({ url: '/JobStatus/JobProperty', params: { jobCardID: jobId } }),
    { enabled: !!jobId }
  );
  const { data: jobTypesQueryData } = useQuery(
    ['jobTypesData', jobId],
    () => Fetch.get({ url: '/JobType', params: { filterByStartStatus: true } }),
    { enabled: !!jobId }
  );
  const { data: customFieldsQueryData } = useQuery(
    ['customFieldsData', Enums.Module.JobCard],
    () => Fetch.get({ url: `/Option?module=${Enums.Module.JobCard}` }),
    { enabled: !!jobId }
  );
  const { data: docSettingsData } = useQuery(
    ['docSettings'],
    async () => {
      const [legacyDocuments, documentDefinition] = await Promise.all([
        DocumentService.getUseLegacyDocuments(),
        DocumentService.getDocumentDefinition()
      ]);
      return { legacyDocuments, documentDefinition };
    },
    { enabled: !!jobId }
  );

  const [customFields, setCustomFields] = useState<any[]>([]);
  const [jobTypes, setJobTypes] = useState<any[]>([]);
  const [printOptions, setPrintOptions] = useState<any[]>([]);

  const employeesAssigned = useRef(false);
  const [job, setJob, getJobValue] = useRefState(null);
  const originalJobRef = useRef<any>(null);

  useEffect(() => {
    if (selectedTab === null && router.isReady) {
      let initTab = 'Overview';
      if (tab === 'communication') initTab = 'Messages';
      else if (tab === 'timers') initTab = 'Timers';
      setSelectedTab(initTab);
    }
  }, [router.isReady, tab]);

  useEffect(() => {
    if (jobQueryData && !job) {
      setJob(jobQueryData);
      setCustomer(jobQueryData.Customer || null);
      setContacts(jobQueryData.Customer?.Contacts || []);
      setContact(jobQueryData.Contact || null);
      setLocations(jobQueryData.Customer?.Locations || []);
      setLocation(jobQueryData.Location || null);
      originalJobRef.current = Helper.clone(jobQueryData);
      employeesAssigned.current = jobQueryData.Employees && jobQueryData.Employees.length > 0;
      setAppointmentEmployees(jobQueryData.Employees);
      setRepeatedAlready(!Helper.isNullOrUndefined(jobQueryData.RepeatJobCardID));
      fetchAppointments();
      getWorkflow();
      // getCounts uses getJobValue() (sync ref) so it works here even before
      // the React state re-render from setJob has propagated.
      getCounts();
    }
  }, [jobQueryData]);

  useEffect(() => {
    if (statusesQueryData && nextJobStatuses.length === 0) {
      setNextJobStatuses(statusesQueryData.Results || []);
    }
  }, [statusesQueryData]);

  useEffect(() => {
    if (jobPropsQueryData && jobProperties.length === 0) {
      const results = jobPropsQueryData.Results || [];
      setJobProperties(results);
      let jobItemProp = results.find((x: any) => x.JobStatusOptionName === Enums.JobStatusOptionName.JobItem);
      setJobInventoryRequired(!!(jobItemProp && jobItemProp.OptionConfiguration === Enums.OptionConfiguration.Required));
      jobItemProp = results.find((x: any) => x.JobStatusOptionName === Enums.JobStatusOptionName.Materials);
      setMaterialsRequired(!!(jobItemProp && jobItemProp.OptionConfiguration === Enums.OptionConfiguration.Required));
    }
  }, [jobPropsQueryData]);

  useEffect(() => {
    if (jobTypesQueryData && jobTypes.length === 0) {
      const results = [...(jobTypesQueryData.Results || [])];
      if ((job as any)?.JobType && !results.some((x: any) => x.ID === (job as any).JobType.ID)) {
        results.push((job as any).JobType);
      }
      setJobTypes(results);
    }
  }, [jobTypesQueryData, job]);

  useEffect(() => {
    if (customFieldsQueryData && customFields.length === 0) {
      setCustomFields(customFieldsQueryData.Results || []);
    }
  }, [customFieldsQueryData]);

  useEffect(() => {
    if (docSettingsData && printOptions.length === 0) {
      const { legacyDocuments, documentDefinition } = docSettingsData;
      let opts = [
        { text: 'Customer', link: `GetJobCustomerDocument?jobCardID=${jobId}`, customerZonePrintable: true },
        { text: 'Workshop', link: `GetJobWorkshopDocument?jobCardID=${jobId}` },
        { text: 'Sign Off', link: `GetJobSignOffDocument?jobCardID=${jobId}` },
        { text: 'Job Sheet', link: `GetJobSheetDocument?jobCardID=${jobId}` },
      ];
      if (!legacyDocuments && documentDefinition?.MetaData !== undefined) {
        const metaData = JSON.parse(documentDefinition.MetaData);
        opts = metaData.JobDocuments.filter((x: any) => x.IsActive).sort((a: any, b: any) => a.DocumentType - b.DocumentType).map((jd: any) => ({
          text: jd.Title, link: `GetJobDocument?documentType=${jd.DocumentType}&jobCardID=${jobId}`, customerZonePrintable: jd.CustomerZonePrintable
        }));
      }
      setPrintOptions(opts);
    }
  }, [docSettingsData, jobId]);

  useEffect(() => {
    const handleRouteChange = (url: any, x: any) => {
      if (url.endsWith('?tab=timers')) {
        setSelectedTab('Timers')
      }
    }
    router.events.on('routeChangeStart', handleRouteChange)
    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      router.events.off('routeChangeStart', handleRouteChange)
    }
  }, [router])

  const [jobInventoryUsed, jobInventoryWorkedOn, updateJobInventory] = useJobInventoryState(job, setJob, getJobValue);

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }

    // preparing permissions relevant to buttons that are misbehaving
    let disable = subscriptionInfo.AccessStatus === Enums.AccessStatus.LockedWithAccess || subscriptionInfo.AccessStatus === Enums.AccessStatus.LockedWithOutAccess;
    let disableArchive = !PS.hasPermission(Enums.PermissionName.ArchiveJob) || disable;
    setArchiveDisabled(disableArchive);
    let disableClose = !PS.hasPermission(Enums.PermissionName.CloseJob) || disable;
    setCloseDisabled(disableClose);
  };

  const getFormDefinitions = async () => {
    const request = await Fetch.post({
      url: `/FormDefinition/GetFormDefinitions`,
      params: {}
    });
    let items = request.Results;
    if (items && items.length > 0) {
      setFormDefinitions(items);
    }
  };

  const formsClose = () => {
    setShowFormsModal(false);
  };

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, saveJob);

  function updateJob(field: any, value: any, orKeyValues: any, setIsDirty = true) {
    let newJobState = Helper.clone(getJobValue());

    if (orKeyValues && orKeyValues.length > 0) {
      orKeyValues.map((item: any) => {
        newJobState[item.key] = item.value;
      });
    }
    if (field) {
      newJobState[field] = value;
      if (field == "Employees") {
        setAppointmentEmployees(value);
      }
    }

    setJob(newJobState);
    setFormIsDirty(formIsDirty || setIsDirty);
  }

  const exportDocument = async (endPoint: any, mode = 'view') => {

    const doDownload = () => {
      DownloadService.downloadFile("GET", `/Job/${endPoint}`, null, mode === 'view', false, "", "", null, false, () => {
        setIsPrinting(false);
      });
    };

    setIsPrinting(true);
    if (formIsDirty) {
      let result = await saveJob();
      if (result) {
        doDownload();
      }
    } else {
      doDownload();
    }
  };

  const handleOpenPrint = () => {
    setShowPrintModal(true);
  };

  const handlePrintLabel = async (quantity: any) => {
    setIsPrinting(true);
    try {
      await DownloadService.downloadFile(
        'POST',
        '/Job/PrintJobBarcodeDocument',
        {
          BarcodeDocumentType: Enums.PrintLabelType.JobCard,
          ItemIDs: [(job as any).ID],
          Copies: quantity,
        },
        true,
        false
      );
    } catch (error) {
      console.error('Error printing labels:', error);
      showNotification({
        message: (error as any)?.message || 'Failed to print labels',
        autoClose: 3000,
        color: 'yellow',
      });
    } finally {
      setIsPrinting(false);
    }
  };

  const handlePrintAssetLabel = async (quantity: any) => {
    setIsPrinting(true);
    try {
      await DownloadService.downloadFile(
        'POST',
        '/Job/PrintJobBarcodeDocument',
        {
          BarcodeDocumentType: Enums.PrintLabelType.JobAsset,
          ItemIDs: (job as any).JobInventory.filter((x: any) => !!x.ProductID).map((x: any) => x.ID),
          Copies: quantity,
        },
        true,
        false
      );
    } catch (error) {
      console.error('Error printing asset labels:', error);
      showNotification({
        message: (error as any)?.message || 'Failed to print asset labels',
        autoClose: 3000,
        color: 'yellow',
      });
    } finally {
      setIsPrinting(false);
    }
  };

  const [optionButtons, setOptionButtons] = useState<any[]>([]);

  const {data: companyDetails} = useQuery(['companyDetails'], () => Fetch.get({url: '/Company'}))
  const [selectedQuote, setSelectedQuote] = useState<any>(null)
  const [createNewQuote, setCreateNewQuote] = useState(false)
  const [createNewCopyQuote, setCreateNewCopyQuote] = useState<any>(null)
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null)
  const [createNewInvoice, setCreateNewInvoice] = useState(false)
  const [createNewCopyInvoice, setCreateNewCopyInvoice] = useState<any>(null)
  // Refresh tokens to trigger LinkedItemsList queries after saves
  const [quotesRefreshToken, setQuotesRefreshToken] = useState(0)
  const [invoicesRefreshToken, setInvoicesRefreshToken] = useState(0)
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState<any>(null)
  const [createNewPurchaseOrder, setCreateNewPurchaseOrder] = useState(false)
  const [createNewCopyPurchaseOrder, setCreateNewCopyPurchaseOrder] = useState<any>(null)
  const startNewPurchaseOrder = (copyFrom: any = null) => {
    setSelectedPurchaseOrder(null)
    setCreateNewCopyPurchaseOrder(copyFrom)
    setCreateNewPurchaseOrder(true)
  }
  const [purchaseOrdersRefreshToken, setPurchaseOrdersRefreshToken] = useState(0)

  const optionsClick = async (link: any) => {

    let routeChange = true;
    if (formIsDirty) {
      routeChange = await saveJob(routeChange);
    }

    if (routeChange) {
      switch (link) {
        case 'CreateJob':
          Helper.nextRouter(Router.push, `/job/create`);
          break;
        case 'CreateRecurringJob':
          Helper.nextRouter(Router.push, `/job-schedule/create?module=${Enums.Module.JobCard}&moduleID=${job.ID!!!}&customerID=${customer.ID}`);
          break;
        case 'CreateRepeatJob':
          setShowRepeatModal(true);
          break;
        case 'CreateQuote':
          setCreateNewQuote(true)
          break;
        case 'CreateInvoice':
          setCreateNewInvoice(true);
          break;
        case 'CreatePurchaseOrder':
          startNewPurchaseOrder();
          break;
        case 'OpenCustomer':
          Helper.nextRouter(Router.push, `/customer/[id]`, `/customer/${customer.ID}`);
          break;
        case 'ChangeCustomer':
          setShowChangeCustomer(true);
          break;
        case 'CreateQuery':
          Helper.nextRouter(Router.push, `/query/create?module=${Enums.Module.JobCard}&moduleID=${job.ID!!!}&customerID=${customer.ID}`);
          break;
        case 'LinkQuery':
          setShowLinkQueriesModal(true);
          break;
        default:
          break;
      }
    }
  };

  // REPEAT JOB

  const [showRepeatModal, setShowRepeatModal] = useState(false);
  const [repeatedJob, setRepeatedJob] = useState<any>();

  const getRepeatedJob = async () => {
    let linkedJob = await Fetch.get({
      url: `/Job/Get`,
      params: {
        id: (job as any)?.RepeatJobCardID
      }
    });

    setRepeatedJob(linkedJob);
  };

  const [repeatedAlready, setRepeatedAlready] = useState(false);

  useEffect(() => {
    if (repeatedAlready) {
      getRepeatedJob();
    }
  }, [repeatedAlready]);

  const fetchJobDetails = async () => {

    if (!initialTimeout) return;

    try {
      if (job) {
        const updatedJob = await Fetch.get({
          url: '/Job/' + (job as any).ID,
          caller: "pages/job/[id].js:fetchJobDetails()"
        });
        setJob(updatedJob);
        setFormIsDirty(false);
      }
    } catch (error) {
      console.log('fetchJobDetails', error);
    }
  };

  const [appointmentEmployees, setAppointmentEmployees] = useState<any>(null);

  const fetchAppointments = async () => {
    const currentJob = getJobValue();
    if (!currentJob) return;
    if (appointments.length == 0) {
      const appointmentsRes = await Fetch.get({
        url: '/Appointment/GetItemAppointments',
        params: {
          ItemId: (currentJob as any).ID
        }
      });
      setAppointments(appointmentsRes.Results);
    }
  };

  const fetchTimers = async (force: any) => {
    const currentJob = getJobValue();
    if (!currentJob) return timers;
    if (timers.length == 0 || force === true) {
      try {
        const timersRes = await Fetch.get({
          url: '/Job/GetJobTimes',
          params: {
            JobId: (currentJob as any).ID
          }
        });
        setTimers(timersRes.Results);
        return timersRes.Results;
      } catch (e) {
        console.log("Fetching timers error", e);
      }
    }
    return timers;
  };

  const trySetSelectedTab = async (tab: any) => {
    if (tab === selectedTab) {
      refreshTabData(true);
      if (tab === "Attachments") {
        setAttachmentRefresh(!attachmentRefresh);
      }
      return;
    }

    if (selectedTab === "Overview" && formIsDirty) {
      setConfirmOptions({
        ...Helper.initialiseConfirmOptions(),
        display: true,
        heading: "Save Changes?",
        text: "Save changes before changing the tab?",
        confirmButtonText: "Save Changes",
        discardButtonText: "Discard Changes",
        showDiscard: true,
        showCancel: true,
        onDiscard: async () => {
          await fetchJobDetails();
          setSelectedTab(tab);
        },
        onConfirm: async () => {
          let result = await saveJob();
          if (result === true) {
            setSelectedTab(tab);
          }
        }
      });
    } else {
      setSelectedTab(tab);
    }
  };

  const refreshTabData = (force: any) => {
    switch (selectedTab) {
      case 'Overview':
        if (formIsDirty) {
          setConfirmOptions({
            ...Helper.initialiseConfirmOptions(),
            display: true,
            heading: "Save Changes?",
            text: "Save changes before refreshing the tab?",
            confirmButtonText: "Save Changes",
            discardButtonText: "Discard Changes",
            showDiscard: true,
            showCancel: true,
            onDiscard: async () => {
              fetchJobDetails();
            },
            onConfirm: async () => {
              let result = await saveJob();
              if (result === true) {
                fetchJobDetails(force);
              }
            }
          });
        } else {
          fetchJobDetails(force);
        }
        break;
      case 'Appointments':
        fetchAppointments(force);
        break;
      case 'Summary':
        break;
      case 'Timers':
        fetchTimers(true);
        break;
      case 'Messages':
        break;
      case 'Materials':
      case 'Costing':
        fetchJobDetails(force);
        break;
      default:
        break;
    }
    getCounts();
  }

  useEffect(() => {
    refreshTabData();
  }, [selectedTab]);

  const oldJobStatus = useRef((job as any)?.JobStatus);
  useEffect(() => {
    if (!job) return;

    let skip = JSON.stringify(oldJobStatus.current) === JSON.stringify((job as any).JobStatus);

    oldJobStatus.current = (job as any).JobStatus;

    if (skip) {
      return;
    }

    const fetchNextStatuses = async () => {
      const statuses = await Fetch.get({
        url: '/JobStatus/Next',
        params: {
          jobCardID: (job as any).ID,
        }
      });
      setNextJobStatuses(statuses.Results ?? []);
    }
    fetchNextStatuses();

    const fetchJobProperties = async () => {
      const jobProps = await Fetch.get({
        url: '/JobStatus/JobProperty',
        params: {
          jobCardID: (job as any).ID
        },
      });
      const results = jobProps.Results ?? [];
      setJobProperties(results);

      // refresh counts when status updated - given time to update
      if (jobProps.HttpStatusCode) {
        getCounts()
      }

      let jobItemProp = results.find((x: any) => x.JobStatusOptionName === Enums.JobStatusOptionName.JobItem);
      setJobInventoryRequired(jobItemProp && jobItemProp.OptionConfiguration === Enums.OptionConfiguration.Required);

      jobItemProp = results.find((x: any) => x.JobStatusOptionName === Enums.JobStatusOptionName.Materials);
      setMaterialsRequired(jobItemProp && jobItemProp.OptionConfiguration === Enums.OptionConfiguration.Required);
    };
    fetchJobProperties();
  }, [(job as any)?.JobStatus]);

  const [quoteCount, setQuoteCount] = useState(0);
  const [queryCount, setQueryCount] = useState(0);
  const [invoiceCount, setInvoiceCount] = useState(0);
  const [purchaseOrderCount, setPurchaseOrderCount] = useState(0);
  const [itemsUsedCount, setItemsUsedCount] = useState(0);
  const [jobTimerCount, setJobTimerCount] = useState(0);
  const [jobStatusChangeCount, setJobStatusChangeCount] = useState(0);
  const [appointmentCount, setAppointmentCount] = useState(0);
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [communicationCount, setCommunicationCount] = useState(0);
  const [stockTransactionCount, setStockTransactionCount] = useState(0);

  const [countsToggle, setCountsToggle] = useState(false);
  const [countsLoaded, setCountsLoaded] = useState(false);
  // "Start timer" is offered on jobs that had no timers when opened, and stays once used
  const [offerTimerChip, setOfferTimerChip] = useState(false);

  const getCountsTimer = useRef(false);
  const getCounts = async () => {
    // Use the synchronous ref (getJobValue) so this can be called immediately
    // after setJob() without waiting for a React state re-render cycle.
    const currentJob = getJobValue() ?? job;

    if ((currentJob as any)?.ID && !getCountsTimer.current) {

      getCountsTimer.current = true;

      setTimeout(() => {
        getCountsTimer.current = false;
      }, COUNT_DEBOUNCE_TIMEOUT);

      let countRequest = await Fetch.get({
        url: `/Job/GetCounts?id=${(currentJob as any).ID}`,
      });

      let result = countRequest.Results;

      setQuoteCount(result.find((x: any) => x.Key == 'Quotes').Value);
      setQueryCount(result.find((x: any) => x.Key == 'Queries').Value);
      setInvoiceCount(result.find((x: any) => x.Key == 'Invoices').Value);
      setPurchaseOrderCount(result.find((x: any) => x.Key == 'PurchaseOrders').Value);
      setItemsUsedCount(result.find((x: any) => x.Key == 'ItemsUsed').Value);
      setJobTimerCount(result.find((x: any) => x.Key == 'JobTimers').Value);
      setJobStatusChangeCount(result.find((x: any) => x.Key == 'JobStatusChanges').Value);
      setAppointmentCount(result.find((x: any) => x.Key == 'Appointments').Value);
      setAttachmentCount(result.find((x: any) => x.Key == 'Attachments').Value);
      setCommunicationCount(result.find((x: any) => x.Key == 'Communication').Value);
      setStockTransactionCount(result.find((x: any) => x.Key == "StockTransactions").Value);

      if (!countsLoaded) {
        setOfferTimerChip(result.find((x: any) => x.Key == 'JobTimers').Value === 0);
      }
      setCountsLoaded(true);
      setCountsToggle(!countsToggle);

    }
  };

  const buildUpPageTabs = () => {
    let tabs = [
      { text: 'Overview', count: '0' },
    ];

    if (hasEmployee) {

      if (hasStockControl === true && hasManageCostingPermission) {
        tabs.push({ text: 'Costing', count: itemsUsedCount, suppressCount: true, newItem: false });
      }
      else {
        tabs.push({ text: 'Materials', count: itemsUsedCount });
      }
      if (jobTimerCount > 0)
        tabs.push({ text: 'Timers', count: jobTimerCount });

      if (queryPermission && queryCount > 0)
        tabs.push({ text: 'Queries', count: queryCount });
      if (quotePermission && quoteCount > 0)
        tabs.push({ text: 'Quotes', count: quoteCount });
      if (invoicePermission && invoiceCount > 0)
        tabs.push({ text: 'Invoices', count: invoiceCount });
      if (purchaseOrderPermission && purchaseOrderCount > 0)
        tabs.push({ text: 'Purchases', count: purchaseOrderCount });

      if (hasStockControl === true && stockTransactionCount > 0) {
        tabs.push({ text: "Stock Transactions", count: stockTransactionCount });
      }

      // a new job only has its starting status, so the summary shows once the status has changed
      if (jobStatusChangeCount > 1)
        tabs.push({ text: 'Summary', count: jobStatusChangeCount });

      tabs.push(...[{ text: 'Attachments', count: attachmentCount },
      { text: 'Messages', count: communicationCount },
      ]);
    } else {
      tabs.push({ text: 'Attachments', count: attachmentCount });
    }

    setPageTabs(tabs);
  };

  useEffect(() => {
    buildUpPageTabs();
  }, [countsToggle, hasStockControl]);

  const onAppointmentRefresh = () => {
    getCounts();
  };

  const onAttachmentRefresh = () => {
    getCounts();
  };

  useEffect(() => {
    // Only call getCounts when a job is actually loaded.
    // getJobValue() reads the synchronous ref so it reflects the value set by
    // setJob() even before the React state re-render has completed.
    if (getJobValue()) {
      getCounts();
    }
  }, [appointments]);

  const [timersFirstLoad, setTimersFirstLoad] = useState(true);

  useEffect(() => {
    if (timersFirstLoad) {
      setTimersFirstLoad(false);
      return;
    }
    getCounts();
  }, [timers]);

  const updateJobInventoryUsed = (field: any, value: any, orKeyValues: any, setIsDirty: any, func: any) => {
    if (func) {
      if (func == 'increment') setItemsUsedCount((count: any) => count + 1);
      else if (func == 'decrement') setItemsUsedCount((count: any) => count - 1);
      setCountsToggle(!countsToggle);
    }

    updateJob(field, value, orKeyValues, setIsDirty);
  };

  useEffect(() => {
    // trigger this once at the beginning to initialise the tab
    // fetchTimers();
    fetchAppointments(); // getCounts is triggered on the hook that is triggered by this fetch
    // fetchJobStatusSummary();
    getAccessStatus();
    // getCounts();
    getWorkflow();

    getVans();

    getFormDefinitions();

    /*featureService.getFeature(constants.features.STOCK_CONTROL).then(feature => {
      setHasStockControl(!!feature);
    })*/

    let opts = [
      { text: 'New Job', link: 'CreateJob' }
    ];

    if (addRecurringJobPermission)
      opts.push({ text: 'Create Recurring Job', link: `CreateRecurringJob` });
    // if (addRepeatJobPermission)
    if (queryPermission) {
      opts.push({ text: 'Create Query', link: `CreateQuery` });
      opts.push({ text: 'Link Query', link: `LinkQuery` });
    }
    if (quotePermission)
      opts.push({ text: 'Create Quote', link: `CreateQuote` });
    if (invoicePermission)
      opts.push({ text: 'Create Invoice', link: 'CreateInvoice' });
    if (purchaseOrderPermission)
      opts.push({ text: 'Create Purchase Order', link: 'CreatePurchaseOrder' });
    if (customerPermission)
      opts.push({ text: 'Open Customer', link: `OpenCustomer` });

    if (moduleChangeCustomerPermission)
      opts.push({ text: "Change Customer", link: "ChangeCustomer" });

    setOptionButtons(opts);
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  // const [commentsPage, setCommentsPage] = useState(0);

  // };

  //     url: '/Comment/GetComments',
  //     params: {
  //       ItemId: job.ID,
  //       PageIndex: page ? page : 0,
  //       PageSize: 5

  //   if (currentComments) {
  //     if (page != commentsPage) {
  //       newComments.push(...currentComments);

  //   newComments.push(...request.Results);

  //   if (request.ReturnedResults < 5) {
  //   } else if (newComments.length == request.TotalResults) {
  //   } else {

  // const [newComment, setNewComment] = useState('');

  //   if (newComment.length != 0) {
  //       url: '/Comment',
  //       params: {
  //         ItemID: job.ID,
  //         CommentText: newComment,
  //         Module: Enums.Module.JobCard,
  //         StoreID: job.StoreID
  //     fetchComments();
  // };

  // WORKFLOW

  const [jobItemSelection, setJobItemSelection] = useState(Enums.JobItemSelection.Disabled);
  const [jobItemOrder, setJobItemOrder] = useState<any>();
  const [jobSingleItem, setJobSingleItem] = useState<any>();

  const getWorkflow = async () => {
    const currentJob = getJobValue();
    if (!currentJob) return;
    const workflow = await Fetch.get({
      url: `/Workflow/${(currentJob as any).WorkflowID}`
    });
    setJobItemSelection(workflow.JobItemSelection);
    setJobItemOrder(workflow.JobItemOrder);
    setJobSingleItem(workflow.SingleItem);
  };

  const getVans = async () => {
    let vansAreSetup = false;
    let vans = await warehouseService.getWarehouses(1, '', Enums.WarehouseType.Mobile);
    if (vans && vans.Results) {
      vansAreSetup = vans.Results.length > 0;
    }
    setHasVans(vansAreSetup);
  };

  const [inputErrors, setInputErrors] = useState<any>({});

  const validate = () => {
    const [isValid, errors] = JobStatusService.validateJob(job, jobProperties);

    if (!isValid) {
      setShowProperties(true);
    }

    if (Helper.isNullOrWhitespace(job.Description!!!)) {
      let temp = { ...errors };
      (temp as any).JobDescription = 'Cannot be empty';
      setInputErrors(temp);
      return { isValid: false, customError: null };
    }

    if (job.Description!!!.length > JobCardLengths.Description) {
      let temp = { ...errors };
      (temp as any).JobDescription = `Cannot be greater than ${JobCardLengths.Description} characters`;
      setInputErrors(temp);
      return { isValid: false, customError: null };
    }

    if (Helper.isNullOrWhitespace(contact)) {
      let temp = { ...errors };
      (temp as any).Contact = 'Cannot be empty';
      setInputErrors(temp);
      return { isValid: false, customError: null };
    }

    if (jobInventoryRequired) {
      let activeJobInventory = job.JobInventory.filter!!!((x: any) => x.IsActive == true && x.StockItemStatus === Enums.StockItemStatus.WorkedOn);
      if (activeJobInventory.length == 0) {
        let temp = { ...errors };
        (temp as any).JobInventory = 'Customer assets are required';
        setInputErrors(temp);
        return { isValid: false, customError: 'Customer assets are required' };
      }
    }

    if (materialsRequired) {
      let activeJobInventory = job.JobInventory.filter!!!((x: any) => x.IsActive == true && x.StockItemStatus === Enums.StockItemStatus.ItemUsed);
      if (activeJobInventory.length == 0) {
        let temp = { ...errors };
        (temp as any).Materials = 'Materials are required';
        setInputErrors(temp);
        return { isValid: false, customError: 'Materials are required' };
      }
    }

    setInputErrors(errors);
    return { isValid: isValid, customError: null };
  };

  const [saving, setSaving] = useState(false);

  const [triggerSaveComment, setTriggerSaveComment] = useState(0);
  async function submitComment() {
    setTriggerSaveComment((x: any) => x + 1);
  }

  const onSavingItems = (val: any) => {
    setSaving(val);
  }

  async function saveJob(routeChange = false) {

    setSaving(true);
    const sections = getSectionsFromTableData(job.JobInventory!!!, 'InventorySectionName', 'InventorySectionID', Enums.Module.JobCard, job.ID!!!);

    let { isValid, customError } = validate();
    if (isValid) {

      await submitComment();

      const jobPut = await Fetch.put({
        url: '/Job',
        params: {
          Job: job,
          InventorySections: sections,
        },
        toastCtx: toast
      });

      if (jobPut.ID) {
        if (!routeChange) {
          toast.setToast!!!({
            message: 'Job saved successfully',
            show: true,
            type: 'success'
          })
        }

        if (jobPut.Employees && jobPut.Employees.length > 0 && !employeesAssigned.current) {
          Helper.mixpanelTrack(constants.mixPanelEvents.jobEmployeeAssigned, {
            "jobID": jobPut.ID
          });
        }

        employeesAssigned.current = jobPut.Employees && jobPut.Employees.length > 0;

        setJob(jobPut);
        // Update the original snapshot to the newly saved state
        originalJobRef.current = Helper.clone(jobPut);
        setFormIsDirty(false);
        setRetriggerAuditLog(!retriggerAuditLog);
      } else {
        // err from server
      }
    } else {
      toast.setToast!!!({
        message: customError ? customError : 'There are errors on the page',
        show: true,
        type: Enums.ToastType.error
      });
    }

    setSaving(false);

    return isValid;
  }

  const [archiving, setArchiving] = useState(false);
  async function archiveJob() {
    setArchiving(true);

    const jobPut = await Fetch.get({
      url: '/Job/Archive?id=' + job.ID!!!,
      toastCtx: toast
    });

    if (jobPut.ID) {
      const message = jobPut.IsArchived ? 'Job archived successfully' : 'Job un-archived successfully'
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          const jobPutInner = await Fetch.get({
            url: '/Job/Archive?id=' + job.ID!!!,
          });
          setJob(jobPutInner);
          // Update snapshot on undo archive as well
          originalJobRef.current = Helper.clone(jobPutInner);
          setFormIsDirty(false);
          setRetriggerAuditLog(!retriggerAuditLog);
        },
        message: message,
        show: true,
        type: 'success'
      })
      setJob(jobPut);
      // Update snapshot on archive/unarchive
      originalJobRef.current = Helper.clone(jobPut);
      setFormIsDirty(false);
      setRetriggerAuditLog(!retriggerAuditLog);
    }

    setArchiving(false);
  }

  const [closing, setClosing] = useState(false);

  const confirmMarkAsUsed = async () => {
    return new Promise((resolve: any, reject: any) => {
      setConfirmOptions({
        ...Helper.initialiseConfirmOptions(),
        display: true,
        heading: "Mark materials as used?",
        text: "Your job preferences allow for closing jobs to mark materials as used. Do you want to mark materials linked to these jobs as used when closing?",
        confirmButtonText: "Mark as Used",
        discardButtonText: "Don't Mark as Used",
        onConfirm: () => {
          resolve(true);
        },
        onDiscard: () => {
          resolve(false);
        },
        showDiscard: true,
        showCancel: false
      })
    });
  }

  async function closeJob() {

    let markAsUsed = false;
    let hasUnusedMaterials = jobInventoryUsed.some((x: any) => x.IsActive && x.QuantityRequested > x.QuantityUsed);

    if (hasStockControl && hasUnusedMaterials) {
      let mustConfirmMarkAsUsed = await jobService.getMarkAsUsedOnClosedOptionValue();

      if (mustConfirmMarkAsUsed) {
        markAsUsed = await confirmMarkAsUsed();
      }
    }

    setClosing(true);

    const jobClose = await Fetch.get({
      url: `/Job/Close?id=${job.ID!!!}&confirmMarkAsUsed=${markAsUsed}`,
      toastCtx: toast
    });

    if (jobClose.ID) {
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          const jobCloseInner = await Fetch.get({
            url: '/Job/Open?id=' + job.ID!!!,
          });
          setJob(jobCloseInner);
          setRetriggerAuditLog(!retriggerAuditLog);
        },
        message: 'Job closed successfully',
        show: true,
        type: 'success'
      })
      setJob(jobClose);
      setFormIsDirty(false);
      setRetriggerAuditLog(!retriggerAuditLog);
    }

    setClosing(false);
    setFormIsDirty(false);
  }

  async function openJob() {
    setClosing(true);

    const jobOpen = await Fetch.get({
      url: '/Job/Open?id=' + job.ID!!!,
      toastCtx: toast
    });

    if (jobOpen.ID) {
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          const jobCloseInner = await Fetch.get({
            url: `/Job/Close?id=${job.ID!!!}&confirmMarkAsUsed=false`,
          });
          setJob(jobCloseInner);
          setRetriggerAuditLog(!retriggerAuditLog);
        },
        message: 'Job opened successfully',
        show: true,
        type: 'success'
      })

      setJob(jobOpen)
      setFormIsDirty(false);
      setRetriggerAuditLog(!retriggerAuditLog);
    }

    setClosing(false);
    setFormIsDirty(false);
  }

  // const [showRepeatModal, setShowRepeatModal] = useState(false);

  const getFormExpired = (formHeader: any) => {
    if (!formHeader.ExpireDate) {
      return false;
    }
    return Time.now().valueOf() > Time.parseDate(formHeader.ExpireDate).valueOf();
  };

  const checkSetNewStatus = async (sts: any) => {
    if (formIsDirty) {
      setConfirmOptions({
        ...Helper.initialiseConfirmOptions(),
        showCancel: false,
        display: true,
        heading: "Cannot change status",
        text: "You will lose unsaved changes."
      });
    } else {
      let canContinue = true;
      let reason = "";

      if (!sts.StartStatus && sts.FormCompleted && job.JobType!!! && job.JobType.FormDefinitions!!! && job.JobType.FormDefinitions.filter!!!((x: any) => x.IsActive).length > 0) {
        let formHeaderResponse = await Fetch.get({
          url: "/Form/GetByItemID",
          params: {
            itemID: job.ID!!!,
            itemModule: Enums.Module.JobCard
          }
        });

        const formHeaders = formHeaderResponse.Results;
        job.JobType.FormDefinitions.filter!!!((x: any) => x.IsActive).forEach((formDefinition: any) => {
          let header = formHeaders.find((x: any) => x.FormDefinition.MasterID === formDefinition.MasterID);
          if (!header || header.FormStatus !== Enums.FormStatus.Completed || getFormExpired(header)) {
            canContinue = false;
            reason = "You need to complete all required forms.";
          }
        });
      }

      if (canContinue && !sts.StartStatus && sts.TaskCompleted) {
        let taskItemResponse = await Fetch.get({
          url: "/TaskItem/GetTaskItemsForItem",
          params: {
            itemID: job.ID!!!,
          }
        });

        const incompleteTaskItems = taskItemResponse.Results.filter((x: any) => x.IsActive && !x.Complete);
        if (incompleteTaskItems.length > 0) {
          canContinue = false;
          reason = "You need to complete all tasks.";
        }
      }

      if (!canContinue) {
        setConfirmOptions({
          ...Helper.initialiseConfirmOptions(),
          showCancel: false,
          display: true,
          heading: "Cannot change status",
          text: reason
        });
      } else {
        // check for running timers

        let latestTimers = await fetchTimers(true);

        let doCheckToStopTimer = true;
        if (sts.EndTimer) {
          doCheckToStopTimer = false;
        }
        // if (Array.isArray(nextJobStatuses)) {

        if (TimerService.isTimerRunning(latestTimers) && doCheckToStopTimer) {
          /*setConfirmOptions({
            ...Helper.initialiseConfirmOptions(),
            showCancel: true,
            confirmButtonText: "Yes",
            onConfirm: async () => {
              await TimerService.stopTimer(latestTimers, employeeID);
              timerContext.updateRunningTimers();
              setNewStatus(sts);
            },
            onCancel() {
              setNewStatus(sts);
            },
            cancelButtonText: "No",
            display: true,
            heading: "Timer is running",
            text: "A timer is currently running, do you wish to stop it before continuing?"
          });*/
          setNewStatus(sts);
          setNewStatusShowStopTimerOption(true)
        } else {
          setNewStatus(sts);
          setNewStatusShowStopTimerOption(false)
        }
      }
    }
  };

  const stopTimerConfirmation = async () => {

  };

  // TIMER: started and stopped from the Actions menu and "Add to this job"; while it runs it shows in the toolbar
  const [timerBusy, setTimerBusy] = useState(false);
  const runningJobTimer = job ? ((timerContext as any).runningTimers || []).find((x: any) => x.JobCardID === (job as any).ID && !x.EndTime) : undefined;
  const canUseTimer = hasEmployee && manageMyTimersPermission && !(job as any)?.IsClosed
      && accessStatus !== Enums.AccessStatus.LockedWithAccess && accessStatus !== Enums.AccessStatus.LockedWithOutAccess;

  const toggleTimer = async () => {
    if (timerBusy) return;
    setTimerBusy(true);
    try {
      if (runningJobTimer) {
        await TimerService.stopTimer([{ ...runningJobTimer }], runningJobTimer.EmployeeID);
        showNotification({ message: 'Timer stopped', color: 'scBlue', autoClose: 3000 });
      } else {
        const { started } = await TimerService.startJobTimer((job as any).ID, Storage.getCookie(Enums.Cookie.employeeID), Storage.getCookie(Enums.Cookie.servUserName));
        if (!started) {
          toast.setToast!!!({
            message: 'There are currently running timer(s) that need to be stopped',
            show: true,
            type: 'error'
          });
          return;
        }
        showNotification({ message: 'Timer started', color: 'scBlue', autoClose: 3000 });
        // the timer is on the job straight away, so its tab shows without waiting for the counts
        setJobTimerCount((c: number) => c + 1);
        setCountsToggle((t: boolean) => !t);
      }
      await (timerContext as any).updateRunningTimers(true);
      if (selectedTab === 'Timers') fetchTimers(true);
    } finally {
      setTimerBusy(false);
    }
  };

  const updateJobFromStatusChange = (job: any) => {
    // fetchJobStatusSummary();
    timerContext.updateRunningTimers!!!(true);
    setJob(job);
    getCounts();
  }

  const items = ['Open customer', 'Create recurring'];
  const dropdownItemClicked = (index: any) => {
    if (index === 0) {
      Helper.nextRouter(Router.push, '/customer/[id]', `/customer/${customer.ID}`);
    } else if (index === 1) {
      Helper.nextRouter(Router.push, `/job-schedule/create?customerID=${customer.ID}`);
    }
  }

  const getClassNameForActions = () => {
    let name = "actions";
    if (hasEmployee === true) {
      if (job.IsClosed!!! === true) {
        name += " actions-less";
      }
    } else {
      name = "actions actions-narrow";
    }
    return name;
  }

  const refreshJob = async (newJob: any) => {
    await Helper.waitABit(500);
    Router.reload();
  };

  // Restore the job to the last saved/original snapshot and reset dirty state
  const discardChanges = () => {
    const original = originalJobRef.current ? Helper.clone(originalJobRef.current) : null;
    if (original) {
      setJob(original);
      // Keep related selection states in sync with the restored job
      try {
        setCustomer(original.Customer || customer);
      } catch {}
      try {
        setContacts((original.Customer && original.Customer.Contacts) ? original.Customer.Contacts : contacts);
      } catch {}
      try {
        setContact(original.Contact || null);
      } catch {}
      try {
        setLocations((original.Customer && original.Customer.Locations) ? original.Customer.Locations : locations);
      } catch {}
      try {
        setLocation(original.Location || null);
      } catch {}
    }
    setInputErrors({});
    setFormIsDirty(false);
  };

  const reloadJobData = async () => {
    let jobData = await jobService.getJob(job.ID!!!);
    setJob(jobData);
    // Keep snapshot in sync with explicitly reloaded data
    originalJobRef.current = Helper.clone(jobData);
  };

  const { height: toolbarHeight, ref: toolbarRef } = useElementSize()
  const [tabsTotalWidth, setTabsTotalWidth] = useState(0);
  const { width: actionsWidth, ref: actionsRef } = useElementSize();

    return (
        <>
            {!job ? <DetailsPageLoader /> : (<>
            <Head><title>{(job as any).JobCardNumber} | Jobs</title></Head>
            {/* The top padding (not a margin) belongs to the sticky box, so when stuck it tucks 10px under the app header and the breadcrumb keeps 5px of room instead of touching the header edge */}
            <Box bg={'white'} ref={toolbarRef} pos={'sticky'} top={'calc(var(--app-shell-header-offset, 40px) - 10px)'} pt={'15px'}
                 style={{zIndex: 100, borderBottom: '1px solid var(--mantine-color-gray-2)'}}>
                <Flex justify={'apart'} w={'100%'} px={'md'}>
                    <Flex align={'center'}>
                        <Breadcrumbs currPage={{text: (job as any).JobCardNumber, link: '/job/' + (job as any).ID, type: 'job-show'}}/>
                    </Flex>
                    <Flex mt={'xs'} mb={'xs'}>
                {(job as any).IsClosed && (
                        <Flex align={'center'} gap={'xs'} ml={'md'}>
                            <Box
                                style={{
                                    width: 16,
                                    height: 16,
                                    borderRadius: '50%',
                                    backgroundColor: 'var(--mantine-color-teal-9)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <IconCheck size={10} color="white" stroke={4} />
                            </Box>
                            <Text size="sm">This job is closed</Text>
                            <Button
                              size="xs"
                              variant="outline"
                              color="gray"
                              onClick={openJob}
                              disabled={closeDisabled || closing}
                              loading={closing}
                              h={32}
                              lh={32}
                              miw={50}
                          >
                              {closing ? 'Opening...' : 'Open'}
                          </Button>
                          </Flex>
                      )}

                    {(job as any).IsArchived && (
                      <Flex align={'center'} gap={'xs'} ml={'md'}>
                          <IconArchive size={16} color="var(--mantine-color-yellow-7)" />
                          <Text size="sm">This job is archived</Text>
                          <Button
                              size="xs"
                              variant="outline"
                              color="gray"
                              onClick={archiveJob}
                              disabled={archiveDisabled || archiving}
                              loading={archiving}
                              h={32}
                              lh={32}
                              miw={50}
                          >
                              {archiving ? 'Unarchiving...' : 'Undo'}
                          </Button>
                      </Flex>
                  )}
                  </Flex>
                </Flex>

                {/* the buttons stop where the section content stops (16px page padding + 21px card edge + the 1100px content width + 16px row padding, less 4px of border),
                    unless the tabs need more room than that: then the row grows, up to the full width, instead of truncating the tabs early */}
                <Flex w={'100%'} maw={Math.max(TOOLBAR_ALIGNED_WIDTH, tabsTotalWidth + actionsWidth + TOOLBAR_SLACK)} mt={5} gap={7}
                      direction={{ base: 'column-reverse', md: 'row' }}
                      wrap='nowrap' align={{ base: 'flex-end', md: 'flex-start' }} px={'md'}>
                  <Box w={{ base: '100%', md: 'auto' }} style={{ flex: '1 1 0', minWidth: 0 }}>
                    <Tabs
                        useNewTabs
                        overflowMenu
                        selectedTab={selectedTab}
                        setSelectedTab={trySetSelectedTab}
                        tabs={pageTabs}
                        onTotalWidth={setTabsTotalWidth}
                        tabsProps={
                            {mt: 0, mx: {base: 1, sm: 'xs', md: 'sm', lg: 'md'}}
                        }
                    />
                  </Box>
                  <Flex ref={actionsRef} gap={7} wrap='nowrap' style={{ flexShrink: 0, overflowX: 'auto' }}>
                      {runningJobTimer &&
                          <JobRunningTimerButton timer={runningJobTimer} busy={timerBusy} onStop={toggleTimer} />
                      }
                      <Button
                          variant="default"
                          px="xs"
                          aria-label="Print"
                          disabled={saving || isPrinting}
                          onClick={() => !saving && !isPrinting && handleOpenPrint()}
                          style={{ minWidth: 'auto', flexShrink: 0 }}
                      >
                          <IconPrinter size={16} />
                      </Button>
                      <Box style={{ flexShrink: 0 }}>
                        <JobActions
                          job={job}
                          setJob={setJob}
                          saveJob={saveJob}
                          archiving={archiving}
                          closing={closing}
                          archiveDisabled={archiveDisabled}
                          closeDisabled={closeDisabled}
                          hasEmployee={hasEmployee}
                          accessStatus={accessStatus}
                          editJobPermission={editJobPermission}
                          onArchive={archiveJob}
                          onClose={closeJob}
                          onOpen={openJob}
                          onCreateQuote={() => setCreateNewQuote(true)}
                          onCreateInvoice={() => setCreateNewInvoice(true)}
                          onCreatePurchaseOrder={() => optionsClick('CreatePurchaseOrder')}
                          moduleChangeCustomerPermission={moduleChangeCustomerPermission}
                          onChangeCustomer={() => setShowChangeCustomer(true)}
                          showFormsButton={formDefinitions.length > 0}
                          onShowForms={() => setShowFormsModal(true)}
                          addRecurringJobPermission={addRecurringJobPermission}
                          onCreateRecurringJob={() => optionsClick('CreateRecurringJob')}
                          onPrint={() => !saving && !isPrinting && handleOpenPrint()}
                          showTimer={canUseTimer}
                          timerRunning={!!runningJobTimer}
                          timerBusy={timerBusy}
                          onToggleTimer={toggleTimer}
                      />
                      </Box>

                      {showPrintModal && (
                          <PrintModal
                              printTemplates={printOptions}
                              exportDocument={exportDocument}
                              onPrintLabel={handlePrintLabel}
                              onPrintAssetLabel={handlePrintAssetLabel}
                              hasAssets={((job as any)?.JobInventory || []).some((x: any) => !!x.ProductID)}
                              onClose={() => setShowPrintModal(false)}
                              isPrinting={isPrinting}
                              jobId={jobId}
                              customerId={customer?.ID}
                              contact={contact}
                              jobIdentifier={(job as any)?.JobCardNumber}
                          />
                      )}

                      <JobStatusChange
                          job={job}
                          nextJobStatuses={nextJobStatuses}
                          checkSetNewStatus={checkSetNewStatus}
                          saving={saving}
                          showFormsButton={formDefinitions.length > 0}
                          onShowForms={() => setShowFormsModal(true)}
                      />
                  </Flex>
                </Flex>
            </Box>
            <Box
                bg={'gray.1'}
                px={'md'}
                pt={'md'}
                pb={'lg'}
                mih={`calc(100vh - ${(toolbarHeight ? (toolbarHeight + 60) : 166)}px${((messageBarContext && (messageBarContext as any).isActive) ? ` - ${constants.messageBarMargin}px` : "")})`}
            >
                {/* Overview now uses a shared card + ScrollArea wrapper moved from JobDetails for consistency */}
                {
                    selectedTab === 'Overview' ? (
                        <>
                                    <JobDetails
                                        onCreateInvoice={() => setCreateNewInvoice(true)}
                                        triggerSaveComment={triggerSaveComment}
                                        customer={customer}
                                        setCustomer={setCustomer}
                                        contacts={contacts}
                                        setContacts={setContacts}
                                        contact={contact}
                                        setContact={setContact}
                                        locations={locations}
                                        setLocations={setLocations}
                                        location={location}
                                        setLocation={setLocation}
                                        job={job}
                                        setJob={setJob}
                                        saveJob={saveJob}
                                        saving={saving}
                                        nextJobStatuses={nextJobStatuses}
                                        checkSetNewStatus={checkSetNewStatus}
                                        updateJob={updateJob}
                                        refreshJob={refreshJob}
                                        discardChanges={discardChanges}
                                        formIsDirty={formIsDirty}
                                        inputErrors={inputErrors}
                                        jobProperties={jobProperties}
                                        accessStatus={accessStatus}
                                        customFields={customFields}
                                        jobTypes={jobTypes}
                                        jobItemSelection={jobItemSelection}
                                        jobItemOrder={jobItemOrder}
                                        jobSingleItem={jobSingleItem}
                                        cypressDescription={'data-cy-description'}
                                        cypressCustomField={'data-cy-custom-field'}
                                        retriggerAuditLog={retriggerAuditLog}
                                        jobInventoryUsed={jobInventoryUsed}
                                        jobInventoryWorkedOn={jobInventoryWorkedOn}
                                        updateJobInventory={(rowVersion: any, jobInventory: any, stockItemStatus: any) => {
                                            updateJobInventory(rowVersion, jobInventory, stockItemStatus);
                                            if (stockItemStatus === Enums.StockItemStatus.ItemUsed || typeof stockItemStatus === 'undefined') {
                                                let newCount = jobInventory.filter((x: any) => x.IsActive && x.StockItemStatus === Enums.StockItemStatus.ItemUsed).length;
                                                setItemsUsedCount(newCount);
                                                setCountsToggle((ct: any) => !ct);
                                            }
                                        }}
                                        setTab={(tab: any) => trySetSelectedTab(tab)}
                                        onSavingItems={onSavingItems}
                                        onOpenQuote={(q: any) => setSelectedQuote(q)}
                                        onOpenInvoice={(inv: any) => setSelectedInvoice(inv)}
                                        onOpenPurchaseOrder={(po: any) => setSelectedPurchaseOrder(po)}
                                        linkedItemsRefreshDeps={{ quotes: quotesRefreshToken, invoices: invoicesRefreshToken, purchaseOrders: purchaseOrdersRefreshToken }}
                                        onAppointmentRefresh={onAppointmentRefresh}
                                        appointmentEmployees={appointmentEmployees}
                                        hasVans={hasVans}
                                        materialsRequired={materialsRequired}
                                        jobInventoryRequired={jobInventoryRequired}
                                        tasksEnabled={tasksEnabled}
                                        quotePermission={quotePermission}
                                        invoicePermission={invoicePermission}
                                        purchaseOrderPermission={purchaseOrderPermission}
                                        onCreateQuote={() => setCreateNewQuote(true)}
                                        onCreatePurchaseOrder={() => optionsClick('CreatePurchaseOrder')}
                                        showStartTimer={canUseTimer && offerTimerChip && !runningJobTimer}
                                        onStartTimer={toggleTimer}
                                        timerBusy={timerBusy}
                                    />

                            {formIsDirty ? (
                                <Box pos={'sticky'} bottom={8} style={{zIndex: 99}}>
                                    <Card
                                        withBorder
                                        shadow={'md'}
                                        p={'md'}
                                        radius={'md'}
                                        mt={14}
                                    >
                                        {/* the buttons line up with the right edge of the section content */}
                                        <Flex align={'center'} justify={'end'} gap={'sm'} w={'100%'} maw={1100}>
                                            <Text size={'sm'} c={'yellow.7'}>You have unsaved changes</Text>
                                            <Flex gap={'sm'} ml={'auto'}>
                                                <Button variant={'subtle'} color={'dark.6'} onClick={discardChanges} disabled={saving}>Discard</Button>
                                                <Button color={'scBlue'} onClick={saveJob} loading={saving}>Save</Button>
                                            </Flex>
                                        </Flex>
                                    </Card>
                                </Box>
                            ) : null}
                        </>
                    ) :

                        // Other components get rendered with card wrapper

                        <Card
                            p={'md'}
                            px={{base: 1, xs: 5, sm: 'sm'}}
                            radius={'md'}
                        >
                            {
                                (() => {
                                    switch (selectedTab) {
                                        case 'Materials':
                                        case 'Costing':
                                            return <Flex direction={'column'} justify={'stretch'} align={'stretch'}>
                                                {hasStockControl && hasManageCostingPermission && <Box>
                                                    <JobInventoryInvoicedWidget job={job}/>
                                                </Box>}
                                                <Box mt={"xl"}>
                                                    {/*Always show the header on the tab (for consistency)*/}
                                                    <Flex align={'center'} gap={'xs'} mb={10}>
                                                        <Text size={'md'} fw={600}>
                                                            Materials / Services
                                                        </Text>
                                                    </Flex>
                                                    {/*{((jobInventoryUsed?.length ?? 0) === 0 || (hasStockControl && hasManageCostingPermission)) &&
                                                        <Flex align={'center'} gap={'xs'} mb={10}>
                                                            <Text size={'md'} fw={600}>
                                                                Materials / Services
                                                            </Text>
                                                        </Flex>
                                                    }*/}
                                                    <ManageJobInventoryComponent
                                                        accessStatus={accessStatus}
                                                        allowNonEmployee={false}
                                                        inputErrors={{JobInventory: inputErrors?.Materials}}
                                                        customerZone={false}
                                                        fromCreateJob={false}
                                                        fromStatusChange={false}
                                                        job={job}
                                                        jobInventoryUsed={jobInventoryUsed}
                                                        jobInventoryWorkedOn={jobInventoryWorkedOn}
                                                        stockItemStatus={Enums.StockItemStatus.ItemUsed}
                                                        key={11}
                                                        onUpdate={(rowVersion: any, jobInventory: any, stockItemStatus: any) => {
                                                            updateJobInventory(rowVersion, jobInventory, stockItemStatus);
                                                            if (stockItemStatus === Enums.StockItemStatus.ItemUsed || typeof stockItemStatus === "undefined") {
                                                                let newCount = jobInventory.filter((x: any) => x.IsActive && x.StockItemStatus === Enums.StockItemStatus.ItemUsed).length;
                                                                setItemsUsedCount(newCount);
                                                                setCountsToggle((ct: any) => !ct);
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                            </Flex>;
                                        case 'Queries':
                                            return <>
                                                <ManageLinksTableV2
                                                    title='Linked Queries'
                                                    item={job}
                                                    itemModule={Enums.Module.JobCard}
                                                    itemDocNumKey={'JobCardNumber'}
                                                    linkItemModule={Enums.Module.Query}
                                                    linkType={Enums.LinkType.JobsToQueries}
                                                    linkItemNumber={2}
                                                    linkItemDocNumKey={'QueryCode'}
                                                    onChange={(links: any) => getCounts()}
                                                    onNoItems={() => {
                                                        setSelectedTab('Overview')
                                                        getCounts()
                                                    }}
                                                    countValue={queryCount}
                                                />
                                                {/*<ManageLinks title='Linked Queries' item={job} itemModule={Enums.Module.JobCard} linkType={Enums.LinkType.JobsToQueries} onChange={(links) => getCounts()} />*/}
                                            </>
                                        case 'Quotes':
                                            return <>
                                                {/*<Text mb={10} mt={'sm'} size={'md'} fw={600}>
                    Linked Quotes
                  </Text>*/}
                                                <ItemQuotesTable itemId={(job as any).ID} customerId={customer?.ID}
                                                                 module={Enums.Module.JobCard} onUpdated={getCounts}/>
                                            </>
                                        case 'Invoices':
                                            return <>
                                                {/*<Text mb={10} mt={'sm'} size={'md'} fw={600}>
                    Linked Invoices
                  </Text>*/}
                                                <JobInvoicesTable itemId={(job as any).ID} customerId={customer?.ID}
                                                                  module={Enums.Module.JobCard}/>
                                            </>
                                        case 'Purchases':
                                            return <>
                                                {/*<Text mb={10} mt={'sm'} size={'md'} fw={600}>
                    Linked Invoices
                  </Text>*/}
                                                <JobPurchasesTable itemId={(job as any).ID} customerId={customer?.ID}
                                                                   module={Enums.Module.JobCard}
                                                                   accessStatus={accessStatus}
                                                                   onSaved={() => {
                                                                       getCounts()
                                                                       setPurchaseOrdersRefreshToken((p: any) => p + 1)
                                                                   }}
                                                                   onCreateNew={() => optionsClick('CreatePurchaseOrder')}
                                                                   onCopyToPurchaseOrder={(po: any) => startNewPurchaseOrder(po)}
                                                                   refreshToken={purchaseOrdersRefreshToken}/>
                                                {/*<PurchaseOrders module={Enums.Module.JobCard} moduleID={job.ID} supplierID={null} accessStatus={accessStatus} />*/}
                                            </>
                                        case 'Appointments':
                                            return <Appointments topMargin={false} module={Enums.Module.JobCard}
                                                                 moduleID={(job as any).ID} customerID={customer?.ID}
                                                                 accessStatus={accessStatus}
                                                                 onRefresh={onAppointmentRefresh}
                                                                 selectedStore={(job as any)?.Store}
                                                                 selectedEmployees={appointmentEmployees}
                                                                 refreshAfterUpdates/>;
                                        case 'Summary':
                                            return <JobStatusSummaryTable jobId={(job as any).ID}/>;
                                        case 'Timers':
                                            return <Timers topMargin={false} timers={timers} jobCard={job}
                                                           setTimers={setTimers} accessStatus={accessStatus}
                                                           refreshTimers={fetchTimers}/>;
                                        case 'Attachments':
                                            return <Attachments topMargin={false} displayName={(job as any).JobCardNumber}
                                                                itemId={(job as any).ID} module={Enums.Module.JobCard}
                                                                onRefresh={onAttachmentRefresh}
                                                                accessStatus={accessStatus}
                                                                triggerRefresh={attachmentRefresh}/>;
                                        case 'Messages':
                                            return <Communications topMargin={false} itemId={(job as any).ID}
                                                                   module={Enums.Module.JobCard}
                                                                   customerID={customer?.ID}
                                                                   selectedContact={contact}
                                                                   itemIdentifier={(job as any).JobCardNumber}
                                                                   accessStatus={accessStatus}/>;
                                        case 'Stock Transactions':
                                            return <ItemStockTransactionsTable itemId={(job as any).ID}
                                                                               itemModule={Enums.Module.JobCard}
                                                                               stockTransactionType={null}
                                                                               accessStatus={accessStatus}
                                                                               appendLinkedItemIDs={true}
                                                                               refreshListToggle={false}/>;
                                        default:
                                            return null;
                                    }
                                })()
                            }
                        </Card>
                }
            </Box>

            <QuoteDrawer
                customerID={!!createNewCopyQuote ? undefined : (job as any).CustomerID}
                module={!!createNewCopyQuote ? undefined : Enums.Module.JobCard}
                moduleID={!!createNewCopyQuote ? undefined : (job as any).ID}
                quote={selectedQuote}
                isNew={createNewQuote}
                show={createNewQuote || !!selectedQuote}
                onClose={
                    () => {
                        setSelectedQuote(null)
                        setCreateNewQuote(false)
                        setCreateNewCopyQuote(null)
                    }
                }
                onSaved={(q: any) => {
                    getCounts()
                    setQuotesRefreshToken((p: any) => p + 1)
                }}
                onCreated={(q: any, close: any) => {
                    if (!close) {
                        setSelectedQuote(q)
                    }
                    setCreateNewQuote(false)
                    setCreateNewCopyQuote(null)
                    getCounts()
                    setQuotesRefreshToken((p: any) => p + 1)
                }}
                accessStatus={accessStatus}
                company={companyDetails}
                copyFromQuote={createNewCopyQuote}
                onCopyToQuote={(q: any) => {
                    setCreateNewQuote(true)
                    setSelectedQuote(null)
                    setCreateNewCopyQuote(q)
                }}
                onCreateNew={
                    () => {
                        setCreateNewQuote(true)
                        setSelectedQuote(null)
                        setCreateNewCopyQuote(null)
                    }
                }
                setIsNew={setCreateNewQuote}
            />

            <InvoiceDrawer
                customerID={!!createNewCopyInvoice ? undefined : (job as any).CustomerID}
                module={!!createNewCopyInvoice ? undefined : Enums.Module.JobCard}
                moduleID={!!createNewCopyInvoice ? undefined : (job as any).ID}
                invoice={selectedInvoice}
                isNew={createNewInvoice}
                show={createNewInvoice || !!selectedInvoice}
                onClose={
                    () => {
                        setSelectedInvoice(null)
                        setCreateNewInvoice(false)
                        setCreateNewCopyInvoice(null)
                    }
                }
                onSaved={(q: any) => {
                    getCounts()
                    reloadJobData();
                    setInvoicesRefreshToken((p: any) => p + 1)
                }}
                onCreated={(q: any, close: any) => {
                    if (!close) {
                        setSelectedInvoice(q)
                    }
                    setCreateNewInvoice(false)
                    setCreateNewCopyInvoice(null)
                    getCounts()
                    reloadJobData();
                    setInvoicesRefreshToken((p: any) => p + 1)
                }}
                accessStatus={accessStatus}
                company={companyDetails}
                copyFromInvoice={createNewCopyInvoice}
                onCopyToInvoice={(q: any) => {
                    setCreateNewInvoice(true)
                    setSelectedInvoice(null)
                    setCreateNewCopyInvoice(q)
                }}
                onCreateNew={
                    () => {
                        setCreateNewInvoice(true)
                        setSelectedInvoice(null)
                        setCreateNewCopyInvoice(null)
                    }
                }
                setIsNew={setCreateNewInvoice}
            />

            <PurchaseOrderDrawer
                purchaseOrder={selectedPurchaseOrder}
                isNew={createNewPurchaseOrder}
                module={Enums.Module.JobCard}
                moduleID={(job as any).ID}
                show={createNewPurchaseOrder || !!selectedPurchaseOrder}
                hostItemID={(job as any).ID}
                copyFromPurchaseOrder={createNewCopyPurchaseOrder}
                onCreateNew={() => startNewPurchaseOrder()}
                onCopyToPurchaseOrder={(po: any) => startNewPurchaseOrder(po)}
                onClose={() => {
                    setSelectedPurchaseOrder(null)
                    setCreateNewPurchaseOrder(false)
                    setCreateNewCopyPurchaseOrder(null)
                }}
                onSaved={() => {
                    getCounts()
                    reloadJobData();
                    setPurchaseOrdersRefreshToken((p: any) => p + 1)
                }}
                onCreated={(po: any) => {
                    // keep the drawer open on the created PO, like quotes and invoices
                    setSelectedPurchaseOrder(po)
                    setCreateNewPurchaseOrder(false)
                    setCreateNewCopyPurchaseOrder(null)
                    getCounts()
                    reloadJobData();
                    setPurchaseOrdersRefreshToken((p: any) => p + 1)
                }}
                accessStatus={accessStatus}
            />

            {showFormsModal && (
              <FormDefinitionsForItem
                customer={(job as any).Customer}
                onClose={formsClose}
                itemID={(job as any).ID}
                itemModule={Enums.Module.JobCard}
                linkedFormDefinitions={(job as any).JobType ? (job as any).JobType.FormDefinitions : []}
                onlyLinkedForms={(job as any).JobType ? (job as any).JobType.OnlyLinkedForms : true}
              />
            )}

            {newStatus && !confirmOptions.display
                ? <StatusChange
                    isNew={false}
                    job={job}
                    jobNumber={(job as any).JobCardNumber}
                    nextJobStatuses={nextJobStatuses}
                    newStatus={newStatus}
                    showStopTimerOption={newStatusShowStopTimerOption}
                    setJob={(job: any, stopTimer: any) => updateJobFromStatusChange(job, stopTimer)}
                    setNewStatus={(s: any) => {
                        setNewStatus(s)
                        setNewStatusShowStopTimerOption(false)
                    }}
                    setFormIsDirty={setFormIsDirty}
                    customFields={customFields}
                    jobInventoryUsed={jobInventoryUsed}
                    jobInventoryWorkedOn={jobInventoryWorkedOn}
                    updateJobInventory={updateJobInventory}
                />
                : ''
            }

            {showRepeatModal ?
                <ManageJobCardRepeat jobCard={job} setJobCard={setJob} saveJobCard={saveJob}
                                     setShowModal={setShowRepeatModal}
                                     repeatedJob={repeatedJob}/> : ''
            }

            <ManageLinksModal
                linkItemModule={Enums.Module.Query}
                linkType={Enums.LinkType.JobsToQueries}
                linkItemDocNumKey={'QueryCode'}
                linkItemNumber={2}
                item={job}
                itemModule={Enums.Module.JobCard}
                itemDocNumKey={'JobCardNumber'}
                title={'Link a Query to Job ' + (job as any).JobCardNumber}
                linkNoun={'Query'}
                linkNounMultiple={'Queries'}
                noItemsText={'There are currently no available queries for ' + (job as any).CustomerName}
                onClose={() => setShowLinkQueriesModal(false)}
                show={showLinkQueriesModal}
                onSuccess={() => {
                    setShowLinkQueriesModal(false);
                    setSelectedTab('Queries');
                    getCounts();
                }}
                onChange={getCounts}
            />

            {showChangeCustomer ?
                <JobCustomerChange job={job} setShowChangeCustomer={setShowChangeCustomer} callback={refreshJob}/>
                : ""}

            <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions}/>

            <style jsx>{`
                .row {
                    display: flex;
                }

                .actions {
                    display: flex;
                    //min-width: 600px;
                    position: relative;
                }

                .actions :global(.button) {
                    margin-left: 0.5rem;
                    margin-top: 0;
                    //padding: 0 1rem;
                    white-space: nowrap;
                }

                .actions.actions-narrow {
                    //min-width: 120px;
                }

                .actions.actions-less {
                    //min-width: 530px;
                }

                .help-dialog {
                    display: flex;
                    align-items: flex-end;
                    padding-left: 0.1rem;
                }

                .repeat-indicator, .scheduled-indicator {
                    position: absolute;
                    margin-left: -2.5rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: ${colors.warningRed};
                    width: 38px;
                    height: 38px;
                    border: 1px solid ${colors.warningRed};
                    border-radius: 3px;
                }

                .option-dropdown {
                    margin-left: 0.5rem;
                }
            `}</style>
            </>)}
        </>
    );
}

// Thin wrapper that keys the inner page by the URL job id so that navigating
// from one /job/<id> URL to another (e.g. via global search) remounts the
// page component with fresh state instead of keeping the previously loaded
// job's local state on screen.
function JobPage() {
    const router = useRouter();
    const { id } = router.query;
    if (!router.isReady || !id) return null;
    return <JobPageInner key={id as string} />;
}

export default JobPage;

export const Route = createFileRoute('/_authenticated/job/$id')({ component: JobPage })
